import { render } from "./Product_List_PopUp.vue?vue&type=template&id=22356546"
import script from "./Product_List_PopUp.vue?vue&type=script&lang=js"
export * from "./Product_List_PopUp.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ET Projeleri\\Erol Teknik Web Uygulamarı\\ETCore_\\etcore-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__